import {combineReducers} from '@reduxjs/toolkit';
import {filesAllSlice} from '../views/all/store';
import {fileDetailsSlice} from '../views/edit/store';

export const filesReducer = combineReducers({
  all: filesAllSlice.reducer,
  details: fileDetailsSlice.reducer,
});
